export default __webpack_public_path__ + "static/media/projector.36e1cf5b.png";